module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/wymiary@3x-780e5dae.svg";